import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { canonicalRole, getSafeLandingPage } from '../lib/roleAccess';
import DashboardPage from './DashboardPage';
import SalesExecutiveDashboardPage from './SalesExecutiveDashboardPage';
import SalesManagerDashboardPage from './SalesManagerDashboardPage';

const Resolving = () => (
  <div className="flex min-h-[60vh] items-center justify-center" data-testid="dashboard-resolving">
    <div className="h-10 w-10 animate-spin rounded-full border-b-2 border-primary" />
  </div>
);

// Role-aware /dashboard entry. The role key is normalised first, so a legacy/variant key
// (sales_manager, seals_manager, ...) still resolves to the Sales Manager dashboard and can
// never fall through to the generic management dashboard. While the role is still resolving
// we render a loader — never a dashboard.
export const DashboardRouter = () => {
  const { user, loading, hasPermission } = useAuth();

  if (loading || !user || !user.role) return <Resolving />;

  if (!hasPermission('dashboard.view')) {
    const target = getSafeLandingPage(user);
    return <Navigate to={target === '/dashboard' ? '/unauthorized' : target} replace />;
  }

  switch (canonicalRole(user.role)) {
    case 'manager':
      return <SalesManagerDashboardPage />;
    case 'sales_executive':
      return <SalesExecutiveDashboardPage />;
    default:
      return <DashboardPage />;
  }
};

export default DashboardRouter;
